import React, { useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleLeft, faAngleRight } from '@fortawesome/free-solid-svg-icons';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import './Pager.css';

const Pager = ({ total, skip, limit, setSkip }) => {
	const { t } = useTranslation();
    const [totalPages, setTotalPages] = useState(0);
    const [currentPage, setCurrentPage] = useState(0);

    useEffect(() => {
        // Вычислим сколько всего страниц
        let rd = total % limit; // остаток от деления
        let tp = (total - rd)/limit; // число страниц
        if(rd) tp ++;
        setTotalPages(tp);
        // Вычислим текущую страницу
        let cp = Math.floor(skip/limit + 1);
        setCurrentPage(cp);
    }, [total, skip, limit]);

    return(
    <React.Fragment>
        {totalPages > 1 &&
        <div className='Pager'>
            {currentPage > 1 ?
            <div className='Pager-prev' onClick={() => setSkip(skip-limit)}>
                <FontAwesomeIcon icon={faAngleLeft} size='lg'/>
                &nbsp;{t('pager.prev')}
            </div> :
            <div className='Pager-prev disabled'>
                <FontAwesomeIcon icon={faAngleLeft} size='lg'/>
                &nbsp;{t('pager.prev')}
            </div>}

            <div className='Pager-current'>
                {t('pager.page')} {currentPage} {t('pager.of')} {totalPages}
            </div>

            {currentPage < totalPages ?
            <div className='Pager-next' onClick={() => setSkip(skip+limit)}>
                {t('pager.next')}&nbsp;
                <FontAwesomeIcon icon={faAngleRight} size='lg'/>
            </div> :
            <div className='Pager-next disabled'>
                {t('pager.next')}&nbsp;
                <FontAwesomeIcon icon={faAngleRight} size='lg'/>
            </div>}
        </div>}
    </React.Fragment>
    );
};

Pager.propTypes = {
    total: PropTypes.number.isRequired,
    skip: PropTypes.number.isRequired,
    limit: PropTypes.number.isRequired,
    setSkip: PropTypes.func.isRequired,
};

export default Pager;
